import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import Alert from '@amzn/meridian/alert';
import AuthCard from '../components/AuthCard';

interface ForgotPasswordScreenProps {
    onBack: () => void;
}

/**
 * Password recovery is admin-assisted. Self-service reset is intentionally not
 * offered: Cognito forbids email-only self-service recovery while email OTP MFA
 * is active (both would use the same email channel, defeating MFA). Suppliers
 * who forget their password contact an administrator, who resets it via
 * AdminSetUserPassword.
 */
export default function ForgotPasswordScreen({ onBack }: ForgotPasswordScreenProps) {
    return (
        <AuthCard title="Forgot password" subtitle="Password resets are handled by an administrator.">
            <Column spacing="400">
                <Alert type="neutral" size="small">
                    To reset your password, contact your Supplier Gateway administrator. For
                    security, self-service reset isn&apos;t available on accounts protected by email
                    verification codes.
                </Alert>
                <Text type="b100" color="secondary">
                    Once an administrator resets your password, sign in with the new password and
                    the verification code emailed to you.
                </Text>
                <Button type="primary" onClick={onBack}>
                    Back to sign in
                </Button>
            </Column>
        </AuthCard>
    );
}
